/**
 * LanguageSelector - Dropdown for selecting code language
 *
 * Used in deployment modals to switch between Python, JavaScript, and cURL.
 */

import React from "react";
import { Dropdown, DropdownItem } from "../../../Dropdown";
import { LANGUAGES, LanguageOption } from "../DeployCodeGenerators";

type Props = {
    selectedLanguage: LanguageOption;
    onLanguageSelect: (language: LanguageOption) => void;
    languages?: LanguageOption[];
};

export function LanguageSelector({ selectedLanguage, onLanguageSelect, languages }: Props) {
    const languageOptions = languages || LANGUAGES;

    return (
        <div className="flex flex-col gap-2">
            <span className="text-sm font-medium text-gray-700">Code Language</span>
            <Dropdown
                theme="light"
                title={selectedLanguage.text}
                onItemSelected={onLanguageSelect as (item: DropdownItem) => void}
                defaultSelectedItem={selectedLanguage as DropdownItem}
                items={languageOptions as DropdownItem[]}
                menuButtonSize="medium"
                className="ml-0"
            />
        </div>
    );
}
